import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  standalone: true,
  imports: [CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CheckboxInputComponent implements ControlValueAccessor {
  @Input() controlId: string | null = null;
  @Input() size: 'small' | 'default' = 'default';
  @Output() checkboxClicked = new EventEmitter<void>();

  public generatedRandomId = `checkbox-${Math.random().toString(36).slice(2)}`;

  private changeDetectorRef = inject(ChangeDetectorRef);

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};
  public disabled: boolean = false;

  isChecked: boolean = false;

  public writeValue(value: boolean): void {
    this.isChecked = value;
    this.changeDetectorRef.markForCheck();
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.changeDetectorRef.markForCheck();
  }

  public toggleCheckbox(): void {
    this.isChecked = !this.isChecked;
    this.onChange(this.isChecked);
    this.onTouched();
    this.checkboxClicked.emit();
  }
}
